import { Button, Dropdown } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

const ButtonReference = ({ setIsMenuOpen, children, ...props }) => (
  <Button variant="link" color="secondary" onClick={() => setIsMenuOpen()} {...props}>
    {children}
  </Button>
);

export function OptionsDropdown({ children, popperOptions, options, ...props }) {
  return (
    <Dropdown
      popperOptions={{
        modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
        ...popperOptions
      }}
      referenceComponent={({ setIsMenuOpen }) => (
        <ButtonReference disabled={props.disabled} setIsMenuOpen={setIsMenuOpen}>
          {children}
        </ButtonReference>
      )}
      popperStyles={{ zIndex: 9 }}
      {...props}
    >
      {({ setIsMenuOpen }) => (
        <S.OptionsDropdownMenu>
          {options.map(item => (
            <Button
              {...item}
              key={item.label}
              color={item.color || 'neutral'}
              variant="text"
              size="sm"
              block
              onClick={e => {
                item.onClick(e);
                setIsMenuOpen(false);
              }}
              style={{
                textTransform: 'none',
                fontWeight: 400,
                fontSize: 14,
                justifyContent: 'flex-start',
                ...(item.style || {})
              }}
            >
              {item.label}
            </Button>
          ))}
        </S.OptionsDropdownMenu>
      )}
    </Dropdown>
  );
}

OptionsDropdown.propTypes = {
  children: PropTypes.any,
  popperOptions: PropTypes.object,
  options: PropTypes.array,
  disabled: PropTypes.bool
};

ButtonReference.propTypes = {
  setIsMenuOpen: PropTypes.func,
  children: PropTypes.any,
  disabled: PropTypes.bool
};
